import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAdminAuth } from '@/hooks/useAdminAuth';
import { Button } from '@/components/ui/Button';
import { Input } from '@/components/ui/Input';
import { Toast } from '@/components/ui/Toast';

export default function AdminLoginPage() {
  const { loginWithPin } = useAdminAuth();
  const navigate = useNavigate();
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState<string | null>(null);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess(null);
    setLoading(true);

    try {
      const role = await loginWithPin(pin);
      if (!role) {
        setError('PIN incorect');
        return;
      }
      setSuccess(`Autentificat ca ${role === 'super_admin' ? 'super admin' : 'admin'}`);
      // Redirectioneaza la moderare dupa 600ms
      setTimeout(() => navigate('/admin/moderate'), 600);
    } catch (e: any) {
      setError(e?.message || 'Eroare la autentificare');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="flex min-h-screen items-center justify-center px-md">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: 'easeOut' }}
        className="w-full max-w-md"
      >
        <div className="rounded-lg border border-border bg-bg-alt p-lg shadow-md">
          <p className="eyebrow mb-sm">Acces restrictionat</p>
          <h1 className="font-serif text-h3 mb-md text-fg">Admin Login</h1>
          <p className="mb-lg text-sm text-fg-soft">
            Introdu PIN-ul pentru a modera pozele evenimentului.
          </p>

          <form onSubmit={onSubmit} className="flex flex-col gap-md">
            <Input
              label="PIN"
              type="password"
              value={pin}
              onChange={(e) => setPin(e.target.value)}
              error={error}
              autoFocus
              autoComplete="off"
            />
            <Button type="submit" variant="primary" fullWidth disabled={loading || !pin}>
              {loading ? 'Se verifică...' : 'Intră'}
            </Button>
          </form>

          <p className="mt-lg text-center text-xs text-fg-soft">
            <button
              type="button"
              onClick={() => navigate('/')}
              className="underline-offset-2 hover:text-fg hover:underline"
            >
              ← Înapoi la eveniment
            </button>
          </p>
        </div>
      </motion.div>

      {success && <Toast message={success} type="success" onClose={() => setSuccess(null)} />}
    </main>
  );
}
